<script lang="ts" setup>
const props = defineProps<{
  title: string;
  desc?: string;
}>();
</script>
<template>
  <div
    class="flex flex-col items-center justify-center h-[200px] px-4 text-base-content"
  >
    <div class="flex flex-col items-center justify-center gap-1">
      <div class="text-xl font-bold text-center">
        {{ props.title }}
      </div>
      <div class="text-center">
        {{ props.desc }}
      </div>
    </div>
  </div>
</template>
